import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SsoBootstrapService } from '@divezone/core';
import { setLogLevel, LogLevel } from "@angular/fire";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('admin');
  private sso = inject(SsoBootstrapService);

  async ngOnInit() {
    setLogLevel(LogLevel.VERBOSE);
    await this.sso.trySsoFromHash();
  }
}
